import { RouterModule, Routes } from "@angular/router";
import { ContactUsComponent } from "./contact-us.component";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContactCardComponent } from "./contact-card/contact-card.component";
import { SharedModule } from "src/app/shared/shared.module";
import { ContactUsFormComponent } from './contact-us-form/contact-us-form.component';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { FormsModule } from "@angular/forms";

  const routes: Routes = [
    {
      path: '',
      component: ContactUsComponent
    }
  ];
  
  @NgModule({
    declarations: [ContactUsComponent, ContactCardComponent, ContactUsFormComponent],
    imports: [
      CommonModule,
      SharedModule,
      FormsModule,
      RouterModule.forChild(routes),
      TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient]
        }
    }),
    ],
    exports:[
        ContactUsComponent
    ],
    schemas:[
        NO_ERRORS_SCHEMA
    ]
  })
  export class ContactUsModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }